<template>
  <div class="px-5 py-5">
    <master-form />
  </div>
</template>
<script>
import MasterForm from "@/pages/teacher-support/components/index.vue";

export default {
    components: {MasterForm}
}
</script>